import { IList, IRecord, IRecordType } from 'annotation-tools/utils';
import { ILabelSummaryType } from './label-summary';
import { IModel, IModelType } from './model';

// immutable object generator
export const IProjectSummary = IRecord<ProjectSummaryType>({
  model: IModel(),
  labels: IList<ILabelSummaryType>()
});

// immutable type
export type IProjectSummaryType = IRecordType<ProjectSummaryType>;

type ProjectSummaryType = {
  model: IModelType;
  labels: IList<ILabelSummaryType>;
};
